export const ferramentasRoutes = [
  {
    path: "/ferramentas",
    name: "ferramentas",
    component: () => import("@/views/ferramentas/HomeFerramentas.vue"),
    meta: { 
      layout: "DefaultLayout",
      title: "Ferramentas Click"
    }
  },

  {
    path: "/homeformacaodepreco",
    name: "home-formacao-de-preco",
    component: () => import("@/views/ferramentas/formacaodepreco/HomeFormacaoDePrecoView.vue"),
    meta: {
      title: "Formação de Preço — Introdução"
    }
  },

  {
    path: "/formacaodepreco",
    name: "formacao-de-preco",
    component: () => import("@/views/ferramentas/formacaodepreco/FormacaoDePrecoView.vue"),
    meta: {
      title: "Formação de Preço"
    }
  },

  {
    path: "/pontodeequilibrio",
    name: "pontodeequilibrio",
    component: () => import("@/views/ferramentas/PontoDeEquilibrioView.vue"),
    meta: {
      title: "Ponto de Equilíbrio"
    }
  },

  // --------------------------------------------------------------------------------

  {
    path: "/ferramentas/simuladordevendas",
    name: "simulador-home",
    component: () => import("@/views/ferramentas/simulador/HomeSimuladorVendasView.vue"),
    meta: {
      title: "Simulador de Vendas"
    }
  },

  {
    path: "/ferramentas/simulador/simuladorautomatico",
    name: "simulador-automatico",
    component: () => import("@/views/ferramentas/simulador/SimuladorVendasAutomaticoView.vue"),
    meta: {
      title: "Simulador Automático de Vendas"
    }
  }
];
